/*
 * Copyright (c) 2025 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { Injectable, Optional } from '@angular/core';
import {
  AbstractResourceService,
  JsonApiListResourceMetadataBase
} from '@irian-ro/abstract-resource';
import { AuthLog } from '../shared-auth-logs/auth-log.model';
import { HttpClient } from '@angular/common/http';
import { EnvironmentService } from '@irian-ro/util-environment';

@Injectable({
  providedIn: 'root'
})
export class OwnedAuthLogsService extends AbstractResourceService<
  AuthLog,
  AuthLog,
  JsonApiListResourceMetadataBase,
  JsonApiListResourceMetadataBase
> {
  ownedAuthLogsUrl = '/api/auth/ownedAuthLogs';

  constructor(private http: HttpClient, @Optional() private environmentService: EnvironmentService) {
    super(
      http,
      environmentService.getEnvironmentProperty('ownedAuthLogsUrl'),
      AuthLog,
      AuthLog,
      JsonApiListResourceMetadataBase
    );

    if (this.environmentService && this.environmentService.getEnvironmentProperty('ownedAuthLogsUrl')) {
      this.ownedAuthLogsUrl = `${ this.environmentService.getEnvironmentProperty('ownedAuthLogsUrl')}`;
    }
  }
}
